import { DndAppActionType } from '../actiontype/dnd-app.actiontype';
import { showHeader, showFooter } from './app.action';
import Page from '../constants/page.enum';
import UtilService from '../services/util.service';
import { setSelectedNumber } from './authorization.action';
import { decideAndOpenLoggedInPage } from './common.action';

export const setUserPreference = (userPreference) => {
    return {
        type: DndAppActionType.USERPREFERENCE,
        payload: userPreference
    }
}

export function openPage(page) {
    UtilService.scrollToTop();
    return {
        type: DndAppActionType.OPEN_PAGE,
        payload: page
    }
}

export const checkRedirection = () => (dispatch, getState) => {
    const state = getState();
    const redirection = state.modalInfo.redirection;
    if (redirection) {
        dispatch(openPage(Page.OLD_DND_HOME_PAGE));
    } else if (UtilService.isMobileApp()) {
        UtilService.closeCurrentMobileWindow();
    }
}

export const returnToHome = () => dispatch => {
    dispatch(checkRedirection());
    dispatch(openPage(Page.HOME_PAGE));
    dispatch(showHeader());
    dispatch(showFooter());
}

export const getSelectedNumberAndOpenLoggedInPage = () => (dispatch, getState) => {
    if (UtilService.isMobileApp()) {
        const selectedNumber = UtilService.getSelectedNumberForApp();
        dispatch(setSelectedNumber(selectedNumber));
        dispatch(decideAndOpenLoggedInPage());
    }
}
